import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { MobileNavigationComponent } from './mobile-navigation/mobile-navigation.component';
import { BodyComponent } from './body/body.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LanguageSwitchComponent,
    MobileNavigationComponent,
    BodyComponent  ],
  imports: [
    SharedModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    BodyComponent
  ],
})
export class LayoutModule {}
